// extracted by mini-css-extract-plugin
module.exports = {"description":"GenericNotification_description__po9ar"};